export default "__VITE_ASSET__d0af1c4b__"